module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "微信支付配置",
      "name": "wxpay"
    }
  }, [_c('wxpayTemplates')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "支付宝支付配置",
      "name": "alipay"
    }
  }, [_c('alipayTemplates')], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a12a5a88", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a12a5a88"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/setting/payment.vue
// module id = 2893
// module chunks = 0